import { Event } from '../../domain/entities/Event';
import { EventRepository } from '../../domain/repositories/EventRepository';

export class GetUpcomingEventsUseCase {
  constructor(private eventRepository: EventRepository) {}

  async execute(): Promise<Event[]> {
    return await this.eventRepository.findUpcoming();
  }
} 